/**
 * The page's one title. Kept in its own module because the header and the
 * panels that render under it live in different folders.
 *
 * It was "Products & Pricing" until 2026-09-13, when the price book merged
 * into the catalogue: there is no longer a product list to name separately
 * from a price list, so the page is called what an operator comes to it for.
 */
export const PRICING_TITLE = "Pricing";
